import { CollegeStatusResponse } from "infrastructure/services/types/college.entity";
import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isInCampaigns: false,
  userType: 0,
} as CollegeStatusResponse;

export const collegeUserReducer = createSlice({
  name: "CollegeUserReducer",
  initialState,
  reducers: {
    saveCollegeUser: (state, action: PayloadAction<CollegeStatusResponse>) => {
      return action.payload;
    },
    resetCollegeUser: () => {
      return initialState;
    },
    setUserType: (state, action: PayloadAction<number>) => {
      return { ...state, userType: action.payload };
    },
  },
});

export const { resetCollegeUser, saveCollegeUser, setUserType } = collegeUserReducer.actions;

export const getCollegeUserRedux = (state: RootState) => state.collegeUserReducer;

export const getIsInCampaignsCollegeUser = (state: RootState) => { return state.collegeUserReducer.isInCampaigns };

export const getCollegeUserType = (state: RootState) => { return state.collegeUserReducer.userType };

export default collegeUserReducer.reducer;
